module.exports = __webpack_public_path__ + "static/rakshasa-e3e65c08e246cca8e896eb9301b95b77.jpg";